import React from "react";
import PropTypes from "prop-types";

import withStyles from '@mui/styles/withStyles';

import QualificationComponent from './QualificationComponent';
import { ReclamationQualificationDetailType } from 'constants.js';
import { ReclamationQualificationDetailCodes } from 'constants.js';


import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';


const acceptationSAVLabel = "Est-ce que le client donne son accord ?";


const styles = theme => ({
    row: {
        flexBasis: '100%',
        marginBottom: '10px'
    },

    formControl: {
        margin: theme.spacing(1)
    },

    group: {
        margin: theme.spacing(1, 0)
    },
    heightLabel: {
        height: '30px'
    },
});




class AcceptationSAV extends QualificationComponent {


    constructor(props) {
        super(props);


        this.state = {
            ...this.state,
            [ReclamationQualificationDetailCodes.AcceptationSAV]: '',
        };

        this.generableCodes = [
            ReclamationQualificationDetailCodes.AcceptationSAV,
        ];
    }


    componentDidMount() {
        const { name } = this.props;
        const { position, toAdd, toDelete } = this.getQualificationData(this.state);

        this.props.onChange(name, position, toAdd, toDelete, "Mount");
    }



    getQualificationData(newState) {

        // Préparation des codes à supprimer (tous les codes générables)
        let toDelete = [...this.generableCodes];


        if (
            newState[ReclamationQualificationDetailCodes.AcceptationSAV] === ''
        ) {
            return {
                name: newState.name,
                position: this.props.position,
                toAdd: null,
                toDelete: toDelete
            };
        }



        let toAdd = [];

        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.AcceptationSAV,
            type: ReclamationQualificationDetailType.Booleen,
            libelle: acceptationSAVLabel,
            valeurBool: newState[ReclamationQualificationDetailCodes.AcceptationSAV],

        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.AcceptationSAV);


        return {
            name: newState.name,
            position: this.props.position,
            toAdd: toAdd,
            toDelete: toDelete
        }
    }


    render() {
        const { classes } = this.props;

        const acceptationSAVValue = this.state[ReclamationQualificationDetailCodes.AcceptationSAV];

        return (
            <div className={classes.row}>

                <FormControl component="fieldset" className={classes.formControl} required>
                    <FormLabel component="legend">{acceptationSAVLabel}</FormLabel>
                    <RadioGroup
                        name={ReclamationQualificationDetailCodes.AcceptationSAV}
                        className={classes.group}
                        value={acceptationSAVValue !== '' ? (acceptationSAVValue ? "true" : "false") : ''}
                        onChange={e => this.handleChange({ target: { name: ReclamationQualificationDetailCodes.AcceptationSAV, value: e.target.value === "true"}})}
                    >
                        <FormControlLabel className={classes.heightLabel} value="true" control={<Radio />} label="Oui" />
                        <FormControlLabel className={classes.heightLabel} value="false" control={<Radio />} label="Non" />
                    </RadioGroup>
                </FormControl>

            </div>
        );
    }

}


AcceptationSAV.propTypes = {
    name: PropTypes.string.isRequired
};

//PropositionAchat.defaultProps = {
//};

export default withStyles(styles)(AcceptationSAV);